__turbopack_context__.v({
  "label": "LifeCharts-module__-l8Xkq__label",
  "page": "LifeCharts-module__-l8Xkq__page",
  "section": "LifeCharts-module__-l8Xkq__section",
});
